// source: billing-concierge.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.concierge_billing.BillingAddress', null, global);
goog.exportSymbol('proto.concierge_billing.BillingConciergeCancellationRequest', null, global);
goog.exportSymbol('proto.concierge_billing.BillingConciergeDiscountRequest', null, global);
goog.exportSymbol('proto.concierge_billing.BillingConciergePriceRangeResponse', null, global);
goog.exportSymbol('proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem', null, global);
goog.exportSymbol('proto.concierge_billing.BillingConciergeResponse', null, global);
goog.exportSymbol('proto.concierge_billing.CreditCardInfo', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceDetailsResponse', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceFilter', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceFilterField', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceRecipient', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceRequest', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceRow', null, global);
goog.exportSymbol('proto.concierge_billing.InvoiceShortResponse', null, global);
goog.exportSymbol('proto.concierge_billing.PaymentInvoiceRequest', null, global);
goog.exportSymbol('proto.concierge_billing.PaymentRequest', null, global);
goog.exportSymbol('proto.concierge_billing.PaymentResponse', null, global);
goog.exportSymbol('proto.concierge_billing.UpdateCreditCardRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingConciergeCancellationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.BillingConciergeCancellationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingConciergeCancellationRequest.displayName = 'proto.concierge_billing.BillingConciergeCancellationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingConciergePriceRangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing.BillingConciergePriceRangeResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing.BillingConciergePriceRangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingConciergePriceRangeResponse.displayName = 'proto.concierge_billing.BillingConciergePriceRangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.displayName = 'proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingConciergeDiscountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.BillingConciergeDiscountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingConciergeDiscountRequest.displayName = 'proto.concierge_billing.BillingConciergeDiscountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingConciergeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.BillingConciergeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingConciergeResponse.displayName = 'proto.concierge_billing.BillingConciergeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.UpdateCreditCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.UpdateCreditCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.UpdateCreditCardRequest.displayName = 'proto.concierge_billing.UpdateCreditCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.CreditCardInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.CreditCardInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.CreditCardInfo.displayName = 'proto.concierge_billing.CreditCardInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceShortResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.InvoiceShortResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceShortResponse.displayName = 'proto.concierge_billing.InvoiceShortResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing.InvoiceDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing.InvoiceDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceDetailsResponse.displayName = 'proto.concierge_billing.InvoiceDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.InvoiceRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceRow.displayName = 'proto.concierge_billing.InvoiceRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceRecipient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.InvoiceRecipient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceRecipient.displayName = 'proto.concierge_billing.InvoiceRecipient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing.InvoiceRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing.InvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceRequest.displayName = 'proto.concierge_billing.InvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.InvoiceFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.InvoiceFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.InvoiceFilter.displayName = 'proto.concierge_billing.InvoiceFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.BillingAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.BillingAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.BillingAddress.displayName = 'proto.concierge_billing.BillingAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.PaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.PaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.PaymentRequest.displayName = 'proto.concierge_billing.PaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.PaymentInvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.PaymentInvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.PaymentInvoiceRequest.displayName = 'proto.concierge_billing.PaymentInvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing.PaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing.PaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing.PaymentResponse.displayName = 'proto.concierge_billing.PaymentResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingConciergeCancellationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingConciergeCancellationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeCancellationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
feedback: jspb.Message.getFieldWithDefault(msg, 1, ""),
improve: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingConciergeCancellationRequest}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingConciergeCancellationRequest;
  return proto.concierge_billing.BillingConciergeCancellationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingConciergeCancellationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingConciergeCancellationRequest}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeedback(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImprove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingConciergeCancellationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingConciergeCancellationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeCancellationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeedback();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImprove();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string feedback = 1;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.getFeedback = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeCancellationRequest} returns this
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.setFeedback = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string improve = 2;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.getImprove = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeCancellationRequest} returns this
 */
proto.concierge_billing.BillingConciergeCancellationRequest.prototype.setImprove = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingConciergePriceRangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingConciergePriceRangeResponse;
  return proto.concierge_billing.BillingConciergePriceRangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem;
      reader.readMessage(value,proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingConciergePriceRangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
discount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem;
  return proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double amount = 2;
 * @return {number}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 discount = 3;
 * @return {number}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PriceItem items = 1;
 * @return {!Array<!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem>}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem, 1));
};


/**
 * @param {!Array<!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem>} value
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse} returns this
*/
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_billing.BillingConciergePriceRangeResponse.PriceItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing.BillingConciergePriceRangeResponse} returns this
 */
proto.concierge_billing.BillingConciergePriceRangeResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingConciergeDiscountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingConciergeDiscountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingConciergeDiscountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeDiscountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingConciergeDiscountRequest}
 */
proto.concierge_billing.BillingConciergeDiscountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingConciergeDiscountRequest;
  return proto.concierge_billing.BillingConciergeDiscountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingConciergeDiscountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingConciergeDiscountRequest}
 */
proto.concierge_billing.BillingConciergeDiscountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingConciergeDiscountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingConciergeDiscountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingConciergeDiscountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeDiscountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeDiscountRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeDiscountRequest} returns this
 */
proto.concierge_billing.BillingConciergeDiscountRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingConciergeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingConciergeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
subscriptionPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
subscriptionDiscount: jspb.Message.getFieldWithDefault(msg, 5, 0),
autoRenewal: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
nextChargeTime: jspb.Message.getFieldWithDefault(msg, 7, 0),
invoiceNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
invoiceAmount: jspb.Message.getFieldWithDefault(msg, 9, 0),
invoiceChargeTime: jspb.Message.getFieldWithDefault(msg, 10, 0),
card: (f = msg.getCard()) && proto.concierge_billing.CreditCardInfo.toObject(includeInstance, f),
contactName: jspb.Message.getFieldWithDefault(msg, 12, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 13, ""),
deactivatedAt: jspb.Message.getFieldWithDefault(msg, 14, 0),
paymentExpired: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
cancellationReason: jspb.Message.getFieldWithDefault(msg, 16, ""),
rejectionLimit: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingConciergeResponse}
 */
proto.concierge_billing.BillingConciergeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingConciergeResponse;
  return proto.concierge_billing.BillingConciergeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingConciergeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingConciergeResponse}
 */
proto.concierge_billing.BillingConciergeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSubscriptionPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionDiscount(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoRenewal(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextChargeTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceNumber(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInvoiceAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvoiceChargeTime(value);
      break;
    case 11:
      var value = new proto.concierge_billing.CreditCardInfo;
      reader.readMessage(value,proto.concierge_billing.CreditCardInfo.deserializeBinaryFromReader);
      msg.setCard(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeactivatedAt(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentExpired(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCancellationReason(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRejectionLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingConciergeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingConciergeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingConciergeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getSubscriptionPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getSubscriptionDiscount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAutoRenewal();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNextChargeTime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getInvoiceNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInvoiceAmount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getInvoiceChargeTime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCard();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.concierge_billing.CreditCardInfo.serializeBinaryToWriter
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDeactivatedAt();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getPaymentExpired();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getCancellationReason();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRejectionLimit();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional double balance = 3;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double subscription_price = 4;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getSubscriptionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setSubscriptionPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 subscription_discount = 5;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getSubscriptionDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setSubscriptionDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool auto_renewal = 6;
 * @return {boolean}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getAutoRenewal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setAutoRenewal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 next_charge_time = 7;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getNextChargeTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setNextChargeTime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string invoice_number = 8;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getInvoiceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setInvoiceNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 invoice_amount = 9;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getInvoiceAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setInvoiceAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 invoice_charge_time = 10;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getInvoiceChargeTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setInvoiceChargeTime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional CreditCardInfo card = 11;
 * @return {?proto.concierge_billing.CreditCardInfo}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getCard = function() {
  return /** @type{?proto.concierge_billing.CreditCardInfo} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing.CreditCardInfo, 11));
};


/**
 * @param {?proto.concierge_billing.CreditCardInfo|undefined} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
*/
proto.concierge_billing.BillingConciergeResponse.prototype.setCard = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.clearCard = function() {
  return this.setCard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.hasCard = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string contact_name = 12;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string contact_email = 13;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 deactivated_at = 14;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getDeactivatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setDeactivatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool payment_expired = 15;
 * @return {boolean}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getPaymentExpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setPaymentExpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string cancellation_reason = 16;
 * @return {string}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getCancellationReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setCancellationReason = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 rejection_limit = 17;
 * @return {number}
 */
proto.concierge_billing.BillingConciergeResponse.prototype.getRejectionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingConciergeResponse} returns this
 */
proto.concierge_billing.BillingConciergeResponse.prototype.setRejectionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.UpdateCreditCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.UpdateCreditCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.UpdateCreditCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
braintreeNonce: jspb.Message.getFieldWithDefault(msg, 1, ""),
braintreeDeviceData: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.UpdateCreditCardRequest}
 */
proto.concierge_billing.UpdateCreditCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.UpdateCreditCardRequest;
  return proto.concierge_billing.UpdateCreditCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.UpdateCreditCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.UpdateCreditCardRequest}
 */
proto.concierge_billing.UpdateCreditCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeNonce(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeDeviceData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.UpdateCreditCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.UpdateCreditCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.UpdateCreditCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBraintreeNonce();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBraintreeDeviceData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string braintree_nonce = 1;
 * @return {string}
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.getBraintreeNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.UpdateCreditCardRequest} returns this
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.setBraintreeNonce = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string braintree_device_data = 2;
 * @return {string}
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.getBraintreeDeviceData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.UpdateCreditCardRequest} returns this
 */
proto.concierge_billing.UpdateCreditCardRequest.prototype.setBraintreeDeviceData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.CreditCardInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.CreditCardInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.CreditCardInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.CreditCardInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
creditCardNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
expirationMonth: jspb.Message.getFieldWithDefault(msg, 2, ""),
expirationYear: jspb.Message.getFieldWithDefault(msg, 3, ""),
country: jspb.Message.getFieldWithDefault(msg, 4, ""),
postalCode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.CreditCardInfo}
 */
proto.concierge_billing.CreditCardInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.CreditCardInfo;
  return proto.concierge_billing.CreditCardInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.CreditCardInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.CreditCardInfo}
 */
proto.concierge_billing.CreditCardInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreditCardNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationMonth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationYear(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.CreditCardInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.CreditCardInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.CreditCardInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.CreditCardInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreditCardNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpirationMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpirationYear();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPostalCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string credit_card_number = 1;
 * @return {string}
 */
proto.concierge_billing.CreditCardInfo.prototype.getCreditCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.CreditCardInfo} returns this
 */
proto.concierge_billing.CreditCardInfo.prototype.setCreditCardNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string expiration_month = 2;
 * @return {string}
 */
proto.concierge_billing.CreditCardInfo.prototype.getExpirationMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.CreditCardInfo} returns this
 */
proto.concierge_billing.CreditCardInfo.prototype.setExpirationMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string expiration_year = 3;
 * @return {string}
 */
proto.concierge_billing.CreditCardInfo.prototype.getExpirationYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.CreditCardInfo} returns this
 */
proto.concierge_billing.CreditCardInfo.prototype.setExpirationYear = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string country = 4;
 * @return {string}
 */
proto.concierge_billing.CreditCardInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.CreditCardInfo} returns this
 */
proto.concierge_billing.CreditCardInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string postal_code = 5;
 * @return {string}
 */
proto.concierge_billing.CreditCardInfo.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.CreditCardInfo} returns this
 */
proto.concierge_billing.CreditCardInfo.prototype.setPostalCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceShortResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceShortResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceShortResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
organizationId: jspb.Message.getFieldWithDefault(msg, 2, 0),
number: jspb.Message.getFieldWithDefault(msg, 3, ""),
date: jspb.Message.getFieldWithDefault(msg, 4, 0),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceShortResponse}
 */
proto.concierge_billing.InvoiceShortResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceShortResponse;
  return proto.concierge_billing.InvoiceShortResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceShortResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceShortResponse}
 */
proto.concierge_billing.InvoiceShortResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrganizationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {!proto.common.BillingConciergeInvoiceStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceShortResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceShortResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceShortResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrganizationId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 organization_id = 2;
 * @return {number}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getOrganizationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string number = 3;
 * @return {string}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 date = 4;
 * @return {number}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setDate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double amount = 5;
 * @return {number}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional common.BillingConciergeInvoiceStatus status = 6;
 * @return {!proto.common.BillingConciergeInvoiceStatus}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.BillingConciergeInvoiceStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.BillingConciergeInvoiceStatus} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 total_items = 7;
 * @return {number}
 */
proto.concierge_billing.InvoiceShortResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceShortResponse} returns this
 */
proto.concierge_billing.InvoiceShortResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing.InvoiceDetailsResponse.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
number: jspb.Message.getFieldWithDefault(msg, 2, ""),
issueDate: jspb.Message.getFieldWithDefault(msg, 3, 0),
chargeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
refundAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
comment: jspb.Message.getFieldWithDefault(msg, 7, ""),
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.concierge_billing.InvoiceRow.toObject, includeInstance),
recipient: (f = msg.getRecipient()) && proto.concierge_billing.InvoiceRecipient.toObject(includeInstance, f),
accountId: jspb.Message.getFieldWithDefault(msg, 10, 0),
custom: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
status: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceDetailsResponse}
 */
proto.concierge_billing.InvoiceDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceDetailsResponse;
  return proto.concierge_billing.InvoiceDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceDetailsResponse}
 */
proto.concierge_billing.InvoiceDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIssueDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChargeAmount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRefundAmount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 8:
      var value = new proto.concierge_billing.InvoiceRow;
      reader.readMessage(value,proto.concierge_billing.InvoiceRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    case 9:
      var value = new proto.concierge_billing.InvoiceRecipient;
      reader.readMessage(value,proto.concierge_billing.InvoiceRecipient.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountId(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustom(value);
      break;
    case 12:
      var value = /** @type {!proto.common.BillingConciergeInvoiceStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIssueDate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getChargeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getRefundAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.concierge_billing.InvoiceRow.serializeBinaryToWriter
    );
  }
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.concierge_billing.InvoiceRecipient.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCustom();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string number = 2;
 * @return {string}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 issue_date = 3;
 * @return {number}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getIssueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setIssueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double charge_amount = 4;
 * @return {number}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getChargeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setChargeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double refund_amount = 5;
 * @return {number}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getRefundAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setRefundAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string comment = 7;
 * @return {string}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated InvoiceRow rows = 8;
 * @return {!Array<!proto.concierge_billing.InvoiceRow>}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.concierge_billing.InvoiceRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing.InvoiceRow, 8));
};


/**
 * @param {!Array<!proto.concierge_billing.InvoiceRow>} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
*/
proto.concierge_billing.InvoiceDetailsResponse.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.concierge_billing.InvoiceRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing.InvoiceRow}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.concierge_billing.InvoiceRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};


/**
 * optional InvoiceRecipient recipient = 9;
 * @return {?proto.concierge_billing.InvoiceRecipient}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getRecipient = function() {
  return /** @type{?proto.concierge_billing.InvoiceRecipient} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing.InvoiceRecipient, 9));
};


/**
 * @param {?proto.concierge_billing.InvoiceRecipient|undefined} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
*/
proto.concierge_billing.InvoiceDetailsResponse.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 account_id = 10;
 * @return {number}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool custom = 11;
 * @return {boolean}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getCustom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setCustom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional common.BillingConciergeInvoiceStatus status = 12;
 * @return {!proto.common.BillingConciergeInvoiceStatus}
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.BillingConciergeInvoiceStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.common.BillingConciergeInvoiceStatus} value
 * @return {!proto.concierge_billing.InvoiceDetailsResponse} returns this
 */
proto.concierge_billing.InvoiceDetailsResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceRow.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRow.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceRow}
 */
proto.concierge_billing.InvoiceRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceRow;
  return proto.concierge_billing.InvoiceRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceRow}
 */
proto.concierge_billing.InvoiceRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_billing.InvoiceRow.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceRow} returns this
 */
proto.concierge_billing.InvoiceRow.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.concierge_billing.InvoiceRow.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceRow} returns this
 */
proto.concierge_billing.InvoiceRow.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double amount = 3;
 * @return {number}
 */
proto.concierge_billing.InvoiceRow.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceRow} returns this
 */
proto.concierge_billing.InvoiceRow.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.concierge_billing.InvoiceRow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRow} returns this
 */
proto.concierge_billing.InvoiceRow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceRecipient.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceRecipient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceRecipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRecipient.toObject = function(includeInstance, msg) {
  var f, obj = {
company: jspb.Message.getFieldWithDefault(msg, 1, ""),
addressFirstLine: jspb.Message.getFieldWithDefault(msg, 2, ""),
addressSecondLine: jspb.Message.getFieldWithDefault(msg, 3, ""),
city: jspb.Message.getFieldWithDefault(msg, 4, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
state: jspb.Message.getFieldWithDefault(msg, 6, ""),
country: jspb.Message.getFieldWithDefault(msg, 7, ""),
fullName: jspb.Message.getFieldWithDefault(msg, 8, ""),
tax: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceRecipient}
 */
proto.concierge_billing.InvoiceRecipient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceRecipient;
  return proto.concierge_billing.InvoiceRecipient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceRecipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceRecipient}
 */
proto.concierge_billing.InvoiceRecipient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressFirstLine(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressSecondLine(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceRecipient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceRecipient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceRecipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRecipient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddressFirstLine();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressSecondLine();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTax();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string company = 1;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address_first_line = 2;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getAddressFirstLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setAddressFirstLine = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address_second_line = 3;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getAddressSecondLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setAddressSecondLine = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string zip_code = 5;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string state = 6;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country = 7;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string full_name = 8;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string tax = 9;
 * @return {string}
 */
proto.concierge_billing.InvoiceRecipient.prototype.getTax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRecipient} returns this
 */
proto.concierge_billing.InvoiceRecipient.prototype.setTax = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing.InvoiceRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.concierge_billing.InvoiceFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceRequest}
 */
proto.concierge_billing.InvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceRequest;
  return proto.concierge_billing.InvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceRequest}
 */
proto.concierge_billing.InvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = new proto.concierge_billing.InvoiceFilter;
      reader.readMessage(value,proto.concierge_billing.InvoiceFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.concierge_billing.InvoiceFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.concierge_billing.InvoiceRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceRequest} returns this
 */
proto.concierge_billing.InvoiceRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.concierge_billing.InvoiceRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceRequest} returns this
 */
proto.concierge_billing.InvoiceRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.concierge_billing.InvoiceRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceRequest} returns this
 */
proto.concierge_billing.InvoiceRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated InvoiceFilter filters = 5;
 * @return {!Array<!proto.concierge_billing.InvoiceFilter>}
 */
proto.concierge_billing.InvoiceRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.concierge_billing.InvoiceFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing.InvoiceFilter, 5));
};


/**
 * @param {!Array<!proto.concierge_billing.InvoiceFilter>} value
 * @return {!proto.concierge_billing.InvoiceRequest} returns this
*/
proto.concierge_billing.InvoiceRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.concierge_billing.InvoiceFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing.InvoiceFilter}
 */
proto.concierge_billing.InvoiceRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.concierge_billing.InvoiceFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing.InvoiceRequest} returns this
 */
proto.concierge_billing.InvoiceRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.InvoiceFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.InvoiceFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.InvoiceFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.InvoiceFilter}
 */
proto.concierge_billing.InvoiceFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.InvoiceFilter;
  return proto.concierge_billing.InvoiceFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.InvoiceFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.InvoiceFilter}
 */
proto.concierge_billing.InvoiceFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_billing.InvoiceFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.InvoiceFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.InvoiceFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.InvoiceFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.InvoiceFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_billing.InvoiceFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.InvoiceFilter} returns this
 */
proto.concierge_billing.InvoiceFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional InvoiceFilterField field = 2;
 * @return {!proto.concierge_billing.InvoiceFilterField}
 */
proto.concierge_billing.InvoiceFilter.prototype.getField = function() {
  return /** @type {!proto.concierge_billing.InvoiceFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_billing.InvoiceFilterField} value
 * @return {!proto.concierge_billing.InvoiceFilter} returns this
 */
proto.concierge_billing.InvoiceFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.concierge_billing.InvoiceFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.InvoiceFilter} returns this
 */
proto.concierge_billing.InvoiceFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.concierge_billing.InvoiceFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.concierge_billing.InvoiceFilter} returns this
 */
proto.concierge_billing.InvoiceFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.concierge_billing.InvoiceFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.concierge_billing.InvoiceFilter} returns this
 */
proto.concierge_billing.InvoiceFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.BillingAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.BillingAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.BillingAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
addressId: jspb.Message.getFieldWithDefault(msg, 1, 0),
companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstLine: jspb.Message.getFieldWithDefault(msg, 3, ""),
secondLine: jspb.Message.getFieldWithDefault(msg, 4, ""),
city: jspb.Message.getFieldWithDefault(msg, 5, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
state: jspb.Message.getFieldWithDefault(msg, 7, ""),
country: jspb.Message.getFieldWithDefault(msg, 8, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 9, ""),
contactName: jspb.Message.getFieldWithDefault(msg, 10, ""),
tax: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.BillingAddress}
 */
proto.concierge_billing.BillingAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.BillingAddress;
  return proto.concierge_billing.BillingAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.BillingAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.BillingAddress}
 */
proto.concierge_billing.BillingAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddressId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstLine(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondLine(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.BillingAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.BillingAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.BillingAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.BillingAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstLine();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecondLine();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTax();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 address_id = 1;
 * @return {number}
 */
proto.concierge_billing.BillingAddress.prototype.getAddressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setAddressId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_line = 3;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getFirstLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setFirstLine = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string second_line = 4;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getSecondLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setSecondLine = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string zip_code = 6;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string state = 7;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string country = 8;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string contact_email = 9;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string contact_name = 10;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string tax = 11;
 * @return {string}
 */
proto.concierge_billing.BillingAddress.prototype.getTax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.BillingAddress} returns this
 */
proto.concierge_billing.BillingAddress.prototype.setTax = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.PaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.PaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.PaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
autoRenewal: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
braintreeNonce: jspb.Message.getFieldWithDefault(msg, 3, ""),
braintreeDeviceData: jspb.Message.getFieldWithDefault(msg, 4, ""),
optionalRecipient: (f = msg.getOptionalRecipient()) && proto.concierge_billing.InvoiceRecipient.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.PaymentRequest}
 */
proto.concierge_billing.PaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.PaymentRequest;
  return proto.concierge_billing.PaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.PaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.PaymentRequest}
 */
proto.concierge_billing.PaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoRenewal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeNonce(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeDeviceData(value);
      break;
    case 5:
      var value = new proto.concierge_billing.InvoiceRecipient;
      reader.readMessage(value,proto.concierge_billing.InvoiceRecipient.deserializeBinaryFromReader);
      msg.setOptionalRecipient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.PaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.PaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.PaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutoRenewal();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getBraintreeNonce();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBraintreeDeviceData();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptionalRecipient();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.concierge_billing.InvoiceRecipient.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool auto_renewal = 1;
 * @return {boolean}
 */
proto.concierge_billing.PaymentRequest.prototype.getAutoRenewal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.PaymentRequest} returns this
 */
proto.concierge_billing.PaymentRequest.prototype.setAutoRenewal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional double amount = 2;
 * @return {number}
 */
proto.concierge_billing.PaymentRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.PaymentRequest} returns this
 */
proto.concierge_billing.PaymentRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string braintree_nonce = 3;
 * @return {string}
 */
proto.concierge_billing.PaymentRequest.prototype.getBraintreeNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentRequest} returns this
 */
proto.concierge_billing.PaymentRequest.prototype.setBraintreeNonce = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string braintree_device_data = 4;
 * @return {string}
 */
proto.concierge_billing.PaymentRequest.prototype.getBraintreeDeviceData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentRequest} returns this
 */
proto.concierge_billing.PaymentRequest.prototype.setBraintreeDeviceData = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional InvoiceRecipient optional_recipient = 5;
 * @return {?proto.concierge_billing.InvoiceRecipient}
 */
proto.concierge_billing.PaymentRequest.prototype.getOptionalRecipient = function() {
  return /** @type{?proto.concierge_billing.InvoiceRecipient} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing.InvoiceRecipient, 5));
};


/**
 * @param {?proto.concierge_billing.InvoiceRecipient|undefined} value
 * @return {!proto.concierge_billing.PaymentRequest} returns this
*/
proto.concierge_billing.PaymentRequest.prototype.setOptionalRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing.PaymentRequest} returns this
 */
proto.concierge_billing.PaymentRequest.prototype.clearOptionalRecipient = function() {
  return this.setOptionalRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing.PaymentRequest.prototype.hasOptionalRecipient = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.PaymentInvoiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.PaymentInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentInvoiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
invoiceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
braintreeNonce: jspb.Message.getFieldWithDefault(msg, 2, ""),
braintreeDeviceData: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.PaymentInvoiceRequest}
 */
proto.concierge_billing.PaymentInvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.PaymentInvoiceRequest;
  return proto.concierge_billing.PaymentInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.PaymentInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.PaymentInvoiceRequest}
 */
proto.concierge_billing.PaymentInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvoiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeNonce(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBraintreeDeviceData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.PaymentInvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.PaymentInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getBraintreeNonce();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBraintreeDeviceData();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 invoice_id = 1;
 * @return {number}
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.getInvoiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.PaymentInvoiceRequest} returns this
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string braintree_nonce = 2;
 * @return {string}
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.getBraintreeNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentInvoiceRequest} returns this
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.setBraintreeNonce = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string braintree_device_data = 3;
 * @return {string}
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.getBraintreeDeviceData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentInvoiceRequest} returns this
 */
proto.concierge_billing.PaymentInvoiceRequest.prototype.setBraintreeDeviceData = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing.PaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing.PaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing.PaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
optionalTransactionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
optionalTransactionCost: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing.PaymentResponse}
 */
proto.concierge_billing.PaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing.PaymentResponse;
  return proto.concierge_billing.PaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing.PaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing.PaymentResponse}
 */
proto.concierge_billing.PaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalTransactionId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOptionalTransactionCost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing.PaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing.PaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing.PaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing.PaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionalTransactionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptionalTransactionCost();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.concierge_billing.PaymentResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing.PaymentResponse} returns this
 */
proto.concierge_billing.PaymentResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.concierge_billing.PaymentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentResponse} returns this
 */
proto.concierge_billing.PaymentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string optional_transaction_id = 3;
 * @return {string}
 */
proto.concierge_billing.PaymentResponse.prototype.getOptionalTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing.PaymentResponse} returns this
 */
proto.concierge_billing.PaymentResponse.prototype.setOptionalTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double optional_transaction_cost = 4;
 * @return {number}
 */
proto.concierge_billing.PaymentResponse.prototype.getOptionalTransactionCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing.PaymentResponse} returns this
 */
proto.concierge_billing.PaymentResponse.prototype.setOptionalTransactionCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.concierge_billing.InvoiceFilterField = {
  DATE_INVOICE_ISSUE_DATE: 0,
  NUMBER_INVOICE_AMOUNT: 1,
  DROPDOWN_INVOICE_STATUS: 2
};

goog.object.extend(exports, proto.concierge_billing);
